<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p>Você tem certeza que deseja deletar a etiqueta <b>{{ entry.description }}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data() { return { loading: true, formErrors: [] }; },
  props: { entry: Object, modelNameSingular: String },
  components: { BaseDelete },
  methods: {
    destroyEntry() {
      this.loading = true;
      this.$apollo.mutate({ mutation: DESTROY_LABEL, variables: { id: this.entry.id } }).then(response => {
        const errors = response.data.destroyLabel.errors;
        if (errors.length) this.formErrors = errors;
        else { this.$emit("entry-destroyed"); this.$refs.baseDelete.closeDialog(); }
      }).catch(response => console.log(response)).finally(() => (this.loading = false));
    }
  }
};

const DESTROY_LABEL = gql`mutation($id: ID!) { destroyLabel(id: $id) { label { id } errors } }`;
</script>

<style scoped></style>